import { Label } from "../label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../library/select";

interface NormalSelectorProps {
  name?: string;
  title?: string;
  value?: string;
  onChange?: (value: string) => void;
  options: {
    value: string;
    name: string;
  }[];
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
}

export default function NormalSelector({
  name,
  title,
  value,
  onChange,
  options,
  placeholder = "Select an option",
  error = false,
  disabled = false,
}: NormalSelectorProps) {
  return (
    <div className="flex flex-col gap-1.5 [&:last-child:nth-child(odd)]:col-span-2">
      {title && (
        <Label
          htmlFor={name}
          className="text-[#051912] text-sm tracking-[-0.56px] font-normal leading-[1.35]"
        >
          {title}
        </Label>
      )}

      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger
          disabled={disabled}
          id={name}
          className={`bg-[#fcfcfc] border-[#cdd1d0] h-10 rounded-xl px-3 py-2 text-sm w-full ${
            error ? "border-red-500" : ""
          }`}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>

        <SelectContent>
          {options.map((val) => (
            <SelectItem key={val.value} value={val.value}>
              {val.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
